import React, { useEffect, useRef, useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { Alert } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useAuth } from '../../../contexts/AuthContext';
import { useHistory } from 'react-router';
import { Grid } from '@material-ui/core';
import Copyright from '../../../app/Copyright';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export default function EmailSignIn() {
    const DEFAULT_EMAIL_DOMAIN = "meenachilriver.org";
    const FILL_EMAIL_DOMAIN = true;
    const DISABLE_SIGNUP = false;

    const classes = useStyles();

    const auth = useAuth();
    const history = useHistory();
    const emailRef = useRef<HTMLInputElement | null>(null);
    const passwordRef = useRef<HTMLInputElement | null>(null);

    const [loading, setLoading] = useState(false);
    const [redirect, setredirect] = useState(false);
    const [error, setErrorMessage] = useState('');

    useEffect(() => {
        // if (auth?.currentUser)
        //    auth.logout();
        // eslint-disable-next-line 
    }, []);

    useEffect(() => {
        if (redirect) {
            const timer = setTimeout(() => {
                history.push('/');
            }, 1000);
            return () => clearTimeout(timer);
        }
        // eslint-disable-next-line 
    }, [redirect]);

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (emailRef.current?.value && passwordRef.current?.value) {
                let username =  `${emailRef.current.value}${(FILL_EMAIL_DOMAIN && !emailRef.current.value.includes("@")) ? "@" + DEFAULT_EMAIL_DOMAIN : ""}`;
                await auth?.login(username, passwordRef.current.value);
                setredirect(true);
            } else {
                setErrorMessage("You need to input valid user credentials. ")
                setLoading(false);
            }
        } catch (error) {
            setErrorMessage("Signin failed!");
            setLoading(false);
        }
    }

    return (
        <Container component="main" maxWidth="xs" >
            <CssBaseline />
            <div className={classes.paper}>
                {
                    error && <Alert severity="error">{error}</Alert>
                }
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Sign in
                </Typography>

                <form className={classes.form} >
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        inputRef={emailRef}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        inputRef={passwordRef}
                    />
                    <FormControlLabel
                        control={<Checkbox value="remember" color="primary" />}
                        label="Remember me"
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        Sign In
                    </Button>
                    <Grid container justify={'center'} style={{ marginBottom: '15px' }}>
                        <Link href="/mobilesignin" variant="body2">
                            {"or sign in using phone number"}
                        </Link>
                    </Grid>
                    <Grid container>
                        <Grid item xs>
                            <Link href="#" variant="body2">
                                Forgot password?
                            </Link>
                        </Grid>
                        {!DISABLE_SIGNUP &&
                            <Grid item>
                                <Link href="/signup" variant="body2">
                                    {"New User? Sign Up now"}
                                </Link>
                            </Grid>
                        }
                    </Grid>
                </form>
            </div>
            <Box mt={8}>
                <Copyright />
            </Box>
        </Container>
    );
}